import * as React from "react";
import { useSelector } from "react-redux";

import { SpacingToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { getInReviewApplications } from "store/entities/applications";
import { withVar } from "themes/helpers";

import ApplicationItem from "../../components/ApplicationItem";
import EmptyState from "../../components/EmptyState";

const InReviewApps: React.FC = () => {
  const applications = useSelector(getInReviewApplications);

  if (!applications?.length) {
    return <EmptyState />;
  }

  return (
    <Flex column gap={withVar(SpacingToken.Spacing3)} marginBottom="60px" marginTop={withVar(SpacingToken.Spacing3)}>
      {applications?.map(application => <ApplicationItem key={application?.id} application={application} />)}
    </Flex>
  );
};

export default InReviewApps;
